export default function checkEmailFormat(email) {
  const regex = new RegExp("^[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]{2,}.[a-z]{2,}$");
  if (regex.test(email)) return true;
  return false;
}
